import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const clearDowloadVehicleList = () => {
  return {
    'type': ActionTypes.CLEAR_DOWNLOADED_WAIT_HAPPY,
  };
};

export const downloadVehicleList = (dealer) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/happyWaiting/vehicle-list/${dealer}/excel`,
      'authenticated': true,
      'types': [
        ActionTypes.DOWNLOADING_WAIT_HAPPY,
        ActionTypes.DOWNLOADED_WAIT_HAPPY,
        [ActionTypes.DOWNLOADED_WAIT_HAPPY_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

